import { SearchQueryTerm, SearchQueryTermType, SearchQueryTermWithoutPositions } from '../types';

export const isCriterion = (term?: SearchQueryTermWithoutPositions) =>
  term?.type === SearchQueryTermType.CRITERION;

export const isAndOperator = (term?: SearchQueryTermWithoutPositions) =>
  term?.type === SearchQueryTermType.OPERATOR && term.value === 'AND';

export const isOrOperator = (term?: SearchQueryTermWithoutPositions) =>
  term?.type === SearchQueryTermType.OPERATOR && term.value === 'OR';

export const isNotOperator = (term?: SearchQueryTermWithoutPositions) =>
  term?.type === SearchQueryTermType.OPERATOR && term.value === 'NOT';

export const isGroupStart = (term?: SearchQueryTermWithoutPositions) =>
  term?.type === SearchQueryTermType.GROUP_START;

export const isGroupEnd = (term?: SearchQueryTermWithoutPositions) =>
  term?.type === SearchQueryTermType.GROUP_END;

export const areTermsSameType = (
  termA?: SearchQueryTermWithoutPositions,
  termB?: SearchQueryTermWithoutPositions,
) => termA?.type === termB?.type;

export const isOperator = (term?: SearchQueryTermWithoutPositions) =>
  isAndOperator(term) || isOrOperator(term) || isNotOperator(term);

export type CursorMatch = {
  index: number;
  term: SearchQueryTerm;
};

const getTermBounds = (term: SearchQueryTerm) => {
  return { start: term.startPosition, end: term.endPosition };
};

export const findCursorMatch = (
  terms: SearchQueryTerm[],
  cursorPosition: number,
  rawQuery: string,
): CursorMatch | undefined => {
  const previousChar = rawQuery[cursorPosition - 1];
  const canMatchEnd = previousChar !== undefined && !/\s/.test(previousChar);

  for (let index = 0; index < terms.length; index += 1) {
    const term = terms[index];
    const bounds = getTermBounds(term);

    if (cursorPosition > bounds.start && cursorPosition < bounds.end) {
      return { index, term };
    }

    if (cursorPosition === bounds.start) {
      const previousTerm = terms[index - 1];
      const previousBounds = previousTerm ? getTermBounds(previousTerm) : undefined;

      if (previousBounds?.end === cursorPosition && canMatchEnd) {
        return { index: index - 1, term: previousTerm };
      }

      return { index, term };
    }

    if (cursorPosition === bounds.end && canMatchEnd) {
      return { index, term };
    }
  }

  return undefined;
};

export const getInsertionIndex = (terms: SearchQueryTerm[], cursorPosition: number) => {
  for (let index = 0; index < terms.length; index += 1) {
    const bounds = getTermBounds(terms[index]);

    if (!bounds) {
      continue;
    }

    if (cursorPosition <= bounds.start) {
      return index;
    }
  }

  return terms.length;
};
